import {IStore} from "modules/store";
import {parseStateType} from "modules/utils/helpers";
import {createSelector} from "@reduxjs/toolkit";

export const getUserStore = ({user}: IStore) => user;

export const getCurrentUserId = (store: IStore) => store.user.currentUser?.id || 0;

export const getSessionState = createSelector(getUserStore, (state) => state.sessionState);

export const getLoginPayload = createSelector(getUserStore, (state) => state.session);
export const isLoggedIn = createSelector(
	getUserStore,
	(state) => Boolean(state.currentUser)
	// (state) => !!state.currentUser && !!state.currentUser?.isBetaTester
);
export const getIsTermsAccepted = createSelector(getUserStore, (state) => state.terms);
export const getIsUserHasUsername = createSelector(getUserStore, (state) => state.userHasUserName);
export const getCheckUsernameRequestState = createSelector(getUserStore, (state) =>
	parseStateType(state.checkUserNameRequestState)
);
export const getIsThanksForPlayingModalViewed = createSelector(getUserStore, (state) => {
	if (!state.currentUser) {
		return true;
	}

	return state.currentUser.isThanksForPlayingModalViewed;
});

export const getGodModeEnable = createSelector(getUserStore, (state) => state.isGodMode);
